import styled from 'styled-components/macro'

import { Card, ToggleGroup } from '@loadsmart/loadsmart-ui'

import { plural } from 'core/utils/string'

import { BidState } from '../domain/RfpSummary'

const TitleWrapper = styled(Card.Title)`
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

const FilterWrapper = styled(Card.Body)`
  display: flex;
  align-items: flex-start;
`

const options = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Open to bid',
    value: BidState.Open,
  },
  {
    label: 'Submitted',
    value: BidState.Submitted,
  },
  {
    label: 'Results',
    value: BidState.Results,
  },
  {
    label: 'Closed',
    value: BidState.Closed,
  },
]

type BidStateFilter = BidState & {
  All: 'all'
}

type RfpHistoryHeaderProps = {
  rfpCount: number
  filter: string
  onFilterChanged: (bidStateFilter: BidStateFilter) => void
}

export function RfpHistoryHeader({ filter, rfpCount, onFilterChanged }: RfpHistoryHeaderProps) {
  return (
    <Card>
      <TitleWrapper>{`${rfpCount} ${plural('RFP', rfpCount)} in your list`}</TitleWrapper>
      <FilterWrapper>
        <ToggleGroup
          onChange={({ target }) => onFilterChanged(target.value as BidStateFilter)}
          options={options}
          value={filter}
          scale="small"
        />
      </FilterWrapper>
    </Card>
  )
}
